import { Service } from '@roc/feature-app-core';
import { RequestCreditAuthForm } from '../stores/requestCreditAuthStore';

const url = {
  GET_MESSAGE_CONFIG: '/api/v1/loan/caf/getMessageConfig',
  SEND_REQUEST_CREDIT_AUTHORIZATION_EMAIL: '/api/v1/loan/sendRequestAuthIdVerifEmail',
  SEND_CONFIRM_CAF_EMAIL: '/api/v1/loan/public/sendRequestAuthIdConfirmEmail',
  FIND_BORROWERS_AND_LEADS_BY_NAME: '/api/v1/loan/oneTool/findBorrowersAndLeadsByName',
  FIND_BORROWERS_BY_NAME: '/api/v1/loan/oneTool/findBorrowersByName',
  GET_BORROWER_BY_ID: '/api/v1/loan/borrower/getBorrowerById',
  SAVE_FORM_INFORMATION: '/api/v1/loan/public/caf/saveFormInformation',
  SUBMIT_SIGNATURE_CAF: '/api/v1/loan/public/caf/submitSignatureCaf',
  GET_LEAD_BY_ID: '/api/v1/lender/lead/getLeadByIdForUser',
  SUBMIT_CREDIT_BG_AUTH_REQUEST: '/api/v1/loan/borrower/submitCreditBgAuthRequest',
  SAVE_BORROWER: '/api/v1/loan/borrower/saveBorrower',
};

export class RequestCreditAuthService extends Service {

  getMessageConfig(host: string, runCredit: boolean, borrowerId: number, requestToken?: string, lenderId?: number) {
    return this.get(url.GET_MESSAGE_CONFIG, { host, runCredit, borrowerId, requestToken, lenderId });
  }

  sendRequestCreditAuthEmail(data) {
    return this.post(url.SEND_REQUEST_CREDIT_AUTHORIZATION_EMAIL, data);
  }

  sendConfirmCAFEmail(data) {
    return this.post(url.SEND_CONFIRM_CAF_EMAIL, data);
  }

  findBorrowersByName(name: string, cancelToken?) {
    return this.get(
      url.FIND_BORROWERS_BY_NAME,
      { name },
      { disableGlobalLoading: true, cancelToken }
    );
  }

  findBorrowersAndLeadsByName(name: string, cancelToken?) {
    return this.get(
      url.FIND_BORROWERS_AND_LEADS_BY_NAME,
      { name, skipRecordTypeFilter: true },
      { disableGlobalLoading: true, cancelToken }
    );
  }

  fetchBorrowerData(borrowerId) {
    return this.get(url.GET_BORROWER_BY_ID, { borrowerId });
  }

  saveFormInformation(data: RequestCreditAuthForm) {
    return this.post(url.SAVE_FORM_INFORMATION, data);
  }

  submitSignatureCaf(data) {
    return this.post(url.SUBMIT_SIGNATURE_CAF, data);
  }

  fetchLeadData(leadId, businessUnit) {
    return this.get(url.GET_LEAD_BY_ID, { leadId, businessUnit });
  }

  submitCreditBgAuthRequest(request: any, requestToken: string) {
    return this.post(`${url.SUBMIT_CREDIT_BG_AUTH_REQUEST}?requestToken=${requestToken}`, request);
  }

  saveBorrower(borrower) {
    return this.post(url.SAVE_BORROWER, borrower);
  }
}
